import { render, staticRenderFns } from "./transports.vue?vue&type=template&id=372f8ea0&scoped=true&"
import script from "./transports.vue?vue&type=script&lang=js&"
export * from "./transports.vue?vue&type=script&lang=js&"
import style0 from "./transports.vue?vue&type=style&index=0&id=372f8ea0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372f8ea0",
  null
  
)

export default component.exports